




















// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { SizeMap } from '../../../../../../composables'

import { DashmixTheme } from '../../../../contracts'

import { DashmixButton, DashmixIcon, DashmixIconName, DashmixInput } from '../../../atoms'
import { DashmixInputGroup } from '../../InputGroup'

import { inputTypeaheadProps, useInputTypeahead } from './InputTypeahead.hook'
import { InputTypeaheadProps } from './InputTypeahead.contracts'

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const InputTypeahead = defineComponent({
  name: 'InputTypeahead',
  components: { DashmixInputGroup, DashmixIcon, DashmixButton, DashmixInput },
  props: inputTypeaheadProps,
  emits: ['onClear', 'onInput', 'focus', 'blur'],

  setup (props: InputTypeaheadProps, ctx: SetupContext) {
    return {
      ...useInputTypeahead(props, ctx),
      buttonTheme: DashmixTheme,
      icons: DashmixIconName,
      sizes: SizeMap
    }
  }
})

export default InputTypeahead
